import isEmpty from 'lodash/isEmpty';
import { NextSeo } from 'next-seo';
import SEO from 'next-seo.config';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import useUser from 'src/utils/useUser';
// import { useState } from 'react';
import { APP_URL, SHOW_COMMEMORATE } from 'src/constants';
import { decryptionClient } from 'src/services/member-auth/utils/decryption-payload';
// import { WEB_NAME } from 'src/constants/layout';
import { timestamp } from 'src/utils/helper';
import { GET } from 'src/utils/service';
import styled from 'styled-components';

const Layout = dynamic(import('src/components/layouts'));

const PageContactUs = ({ data, navBar }: any) => {
  const _data = useUser();
  const sessionSevId = _data?.user ? decryptionClient(_data?.user) : null;
  return (
    <>
      <NextSeo noindex={false} nofollow={false} {...SEO} />
      <Head>
        <link rel='canonical' href={`${APP_URL}/about-us`} />
        {/* <img
          width='99999'
          height='99999'
          alt='svasds'
          title='svasds'
          className='svgll'
          style={{
            pointerEvents: 'none',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '99vw',
            height: '99vh',
            maxWidth: '99vw',
            maxHeight: '99vh',
            overflow: 'hidden'
          }}
          src='data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSI5OTk5OXB4IiBoZWlnaHQ9Ijk5OTk5cHgiIHZpZXdCb3g9IjAgMCA5OTk5OSA5OTk5OSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48ZyBzdHJva2U9Im5vbmUiIGZpbGw9Im5vbmUiIGZpbGwtb3BhY2l0eT0iMCI+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9Ijk5OTk5IiBoZWlnaHQ9Ijk5OTk5Ij48L3JlY3Q+IDwvZz4gPC9zdmc+'
        ></img> */}
      </Head>
      <Layout sessionSevId={sessionSevId} data={{ header: navBar, footer: navBar }}>
        <ContactWarpper className=' container' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : 'unset' }}>
          <div className='row'>
            <div className='container col-12 col-md-6'>
              {/* <img
              src='/static/images/logo.png'
              alt={WEB_NAME}
              width='100%'
              height='100%'
            /> */}
              <h1 className='heading-badge'>contact</h1>
              {!isEmpty(data) && <div className='contact-box-item' dangerouslySetInnerHTML={{ __html: data }} />}
            </div>
            <div className='block-map col-12 col-md-6'>
              <iframe
                src='https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15498.567194390373!2d100.5643417!3d13.8004541!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xe3055317da98f7!2sThe%20People%20Online%20Publisher!5e0!3m2!1sth!2sth!4v1661145938520!5m2!1sth!2sth'
                width='600'
                height='450'
                style={{ border: 0 }}
                allowFullScreen
                loading='lazy'
                referrerPolicy='no-referrer-when-downgrade'
              ></iframe>
              {/* <div className='overlay-map'></div> */}
            </div>
          </div>
        </ContactWarpper>
      </Layout>
    </>
  );
};

const ContactWarpper = styled.div`
  overflow: hidden;

  img {
    text-align: center;
    display: block;
    width: 300px;
    height: 100%;
    margin: auto;
    max-width: 100%;
    @media (max-width: 690px) {
      display: none;
    }
  }

  .heading-badge {
    display: none;
  }

  .contact-box-item {
    text-align: left;
    padding: 38px 0 38px 0;
    @media (max-width: 690px) {
      padding: 18px 0 0px 0;
    }
    p {
      font-size: 16px;
      br {
        display: none !important;
      }
      &:nth-child(1) {
        font-size: 18px;
      }
      &:nth-child(2) {
        margin-bottom: 15px;
      }
      &:nth-child(odd) {
        margin-bottom: 15px;
      }
    }
  }
  .block-map {
    position: relative;
    display: block;
    margin: auto;
    padding: 30px 0;
    @media (max-width: 690px) {
      padding: 0 0 38px 0;
    }
    iframe {
      margin: 0 0 -6px 0;
      max-width: 100%;
    }
  }
`;

export async function getServerSideProps({ req, res }: any) {
  const initProps: any = {
    statusCode: 200,
    errMessage: null,
    data: [],
    navBar: []
  };

  try {
    const _uri = '/api/footer';
    const fetchMenuNav = await GET('/api/v1.0/navigations/menu-nav?limit=6');

    if (!isEmpty(fetchMenuNav)) initProps.navBar = fetchMenuNav;
    const data = await GET(_uri);
    if (!isEmpty(data)) {
      initProps.data = data;
    }
  } catch (err: any) {
    console.error(`${timestamp()} ==========> SEMINAR ERROR : `, err.message);
    initProps.errMessage = err?.message;
    initProps.statusCode = err?.response?.status || 500;
  }

  return {
    props: initProps
  };
}

export default PageContactUs;
